import React, { useEffect, useState } from 'react';
import {
  Box,
  Circle,
  IconButton,
  Image,
  Input,
  Avatar,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Button,
  MenuDivider,
  keyframes,
  useDisclosure,
} from '@chakra-ui/react';
import { ReactComponent as Logo } from '../../svg/Logo.svg';
import { ReactComponent as Home } from '../../svg/home.svg';
import { ReactComponent as Courses } from '../../svg/book.svg';
import { ReactComponent as Attendance } from '../../svg/attendance.svg';
import { ReactComponent as Quizzes } from '../../svg/puzzle-piece.svg';
import { ReactComponent as LiveSessions } from '../../svg/live-sessions.svg';
import { ReactComponent as Certificates } from '../../svg/Certificates.svg';
import { HamburgerIcon, SearchIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { searchFinal, searchQuery, setAutocompleteVisibility, setSelectedMenuItem } from '../../redux/actions/action';
import { ReactComponent as AnnouncementIcon } from '../../svg/bullhorn.svg';
import AdvancedSearchModal from './AdvancedSearchModal'

import MenuItemComponent from './MenuItemComponent';
import { profileSelector, fetchProfile } from '../../redux/slices/profile';
import { loadMyActivity } from '../../redux/api/apiCalls';

const MenuIcons = [
  { component: Home, name: 'Home', link: '/home', bgColor: '#FD337B' },
  { component: Courses, name: 'Courses', link: '/courses', bgColor: '#FF7251' },
  { component: Quizzes, name: 'Quizzes', link: '/quizzes', bgColor: '#3E59DE' },
  { component: LiveSessions, name: 'Live Sessions', link: '/live-sessions', bgColor: '#FE5858' },
  {
    component: AnnouncementIcon,
    name: 'Announcements',
    link: '/announcements',
    bgColor: '#70b529',
  },
];

const ripple = keyframes`
0% {
		transform: scale(0.85);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
	}
	
	70% {
		transform: scale(1);
		box-shadow: 0 0 0 25px rgba(255, 82, 82, 0);
	}
	
	100% {
		transform: scale(0.85);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
	}
`;

export default function AppBar() {
  const loc = useLocation();
  const dispatch = useDispatch();
  const { headerText, menuItem, parameters, searchVisible } = useSelector((state) => state.headerState);
  const { myActivityData, isLoading: myActivityIsLoading } = useSelector(state => state.myActivityState)
  const { profile } = useSelector(profileSelector);
  const history = useHistory();
  const { displayList, autocompleteVisible } = useSelector(state => state.searchState)
  const [searchText, setSearchText] = useState("")
  const [alert, setAlert] = useState(null)
  const { isOpen, onOpen, onClose } = useDisclosure()


  const changeHandler = (e) => {
    setSearchText(e.target.value)
    dispatch(searchFinal(""))
  }

  const itemSelector = (id) => {
    setSearchText(displayList[id])
    dispatch(searchQuery(displayList[id]))
    dispatch(searchFinal(displayList[id]))
  }

  const keyPressHandler = (e) => {
    if (e.key === "Enter") {
      dispatch(searchFinal(searchText))
      dispatch(setAutocompleteVisibility(false))
    }
  }

  useEffect(() => {
    dispatch(searchQuery(searchText))
    // eslint-disable-next-line
  }, [searchText])

  useEffect(() => {
    if (!myActivityIsLoading && myActivityData.length) {
      let filteredActivity = myActivityData.filter(activity => Date.parse(activity.date) >= Date.now()).sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
      setAlert(filteredActivity.length ? filteredActivity[0] : [])
    }
  }, [myActivityData, myActivityIsLoading])


  const animation = `${ripple} 1.5s linear infinite`;

  console.log('profile==>', profile);

  const clickHandler = (id) => {
    dispatch(setSelectedMenuItem(id));
  };
  //const user = JSON.parse(localStorage.getItem('user'));
  useEffect(() => {
    dispatch(fetchProfile());
    if (myActivityData.length === 0) {
      dispatch(loadMyActivity())
    }
    // eslint-disable-next-line
  }, []);

  const logout = () => {
    localStorage.clear();
    history.push('/login');
  };

  return (
    loc.pathname !== '/login' &&
    loc.pathname !== '/forgot' &&
    localStorage.getItem('user') && (
      <Box
        width='100%'
        d='flex'
        justifyContent='space-between'
        alignItems='center'
        bgColor='white'
        px={['1rem', '1rem', '1rem', '3rem']}
        boxShadow='0px 2px 20px rgba(0, 0, 0, 0.1)'
        position='fixed'
        zIndex='10'
        h='10vh'
        onClick={(e) => {
          e.stopPropagation()
          dispatch(setAutocompleteVisibility(false))
        }}
      >
        <Box
          d='flex'
          alignItems='center'
          justifyContent='flex-start'
          style={{ gap: '2rem' }}
          width={['70%', '60%', '50%']}
          my='1rem'
        >
          <Logo width='60px' height='60px' />
          <Box width='60%' position='relative' d={['none', 'none', 'none', searchVisible ? 'flex' : 'none']} justifyContent='center' alignItems='center'>
            <InputGroup d={['none', 'none', 'none', 'none', 'flex']} w='70%'>
              <InputLeftElement children={<SearchIcon color='#999999' />} pointerEvents='none' />
              <Input
                placeholder='Search'
                borderRadius='2xl'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontSize='16px'
                fontWeight='600'
                bg='#f2f2f2'
                value={searchText}
                onChange={changeHandler}
                onClick={(e) => e.stopPropagation()}
                onKeyPress={keyPressHandler}
                onFocus={(e) => {
                  e.stopPropagation()
                  dispatch(setAutocompleteVisibility(true))
                }}
              />
            </InputGroup>
            <Box
              position='absolute'
              display={autocompleteVisible ? 'flex' : 'none'}
              justifyContent='flex-start'
              flexDirection='column'
              top='100%'
              left='0'
              bg='white'
              width='95%'
              fontSize={['10px', '10px', '10px', '10px', '12px']}
              style={{ fontFamily: 'Mulish, sans-serif' }}
              padding='1rem 0'
              borderBottomRadius='10px'
              zIndex='10'
            >
              {
                displayList.length > 0 ? displayList.map((item, id) => <Text
                  key={id}
                  padding='3px 1rem'
                  onClick={() => itemSelector(id)}
                  cursor='pointer'
                  _hover={{ backgroundColor: '#efefef' }}
                >
                  {item}
                </Text>)
                  :
                  <Text
                    pointerEvents='none'
                    padding='3px 1rem'
                  >
                    No matching term!
                  </Text>
              }
            </Box>
            <Text
              fontWeight='700'
              fontSize={['10px', '10px', '12px']}
              style={{ fontFamily: 'Mulish, sans-serif' }}
              onClick={onOpen}
              color='green'
              cursor='pointer'
              width='fit-content'
              ml='1rem'
            >
              Advanced Search
            </Text>
          </Box>
          <Text
            d={['flex', 'flex', 'flex', 'flex', 'none']}
            fontSize={['20px', '25px', '30px', '40px']}
            fontWeight='900'
            style={{ fontFamily: 'Mulish, sans-serif' }}
          >
            {headerText}
          </Text>
        </Box>

        <Box
          d={['none', 'none', 'none', 'none', 'flex']}
          justifyContent='space-around'
          alignItems='center'
          width={[null, null, null, '65%', '60%']}
          height='100%'
        >
          {MenuIcons.map((item, idx) => (
            <MenuItemComponent
              menuText={item.name}
              Component={item.component}
              key={idx}
              selected={menuItem === idx}
              link={item.link}
              clickHandler={clickHandler}
              index={idx}
              bgColor={item.bgColor}
            />
          ))}

          <Menu>
            <MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0}>
              <Avatar
                size={'md'}
                src={profile.length !== 0 && `${profile['avatar']}`}
                name={profile.length !== 0 && `${profile['first_name']} ${profile['last_name']}`}
                position='relative'
              />
              {(alert?.status === 'E' || alert?.status === 'F' || alert?.status === 'S') &&
                <Box
                  position='absolute'
                  top='0'
                  right='-0.25em'
                  width='1em'
                  height='1em'
                  borderRadius='50%'
                  bg={alert?.status === 'S' ? 'green' : 'red'}
                  animation={animation}
                ></Box>
              }
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => history.push('/profile')}>
                {profile.length !== 0 && `${profile['first_name']}  ${profile['last_name']} `}
                (Profile)
              </MenuItem>
              <MenuItem onClick={() => history.push('/my-activity')}>Activity</MenuItem>
              <MenuItem onClick={() => history.push('/attendance')}>Attendance</MenuItem>
              <MenuItem onClick={() => history.push('/certificates')}>Certificates</MenuItem>
              <MenuDivider />
              <MenuItem onClick={() => logout()}>Logout</MenuItem>
            </MenuList>
          </Menu>
        </Box>
        <Box
          d={['flex', 'flex', 'flex', 'flex', 'none']}
          justifyContent='center'
          alignItems='center'
        >
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<HamburgerIcon width='25px' height='25px' />}
              bg='transparent'
              aria-label='Options'
              _hover={{ bg: '#f8f8f8' }}
              _active={{ bg: '#f8f8f8' }}
              size={['xs', 'sm', 'md', 'lg']}
              p={['0.5rem', '0.5rem', '0.75rem']}
              zIndex='5'
              d={['flex', 'flex', 'flex', 'flex', 'none']}
            />
            <MenuList
              style={{ fontFamily: 'Mulish, sans-serif' }}
              fontWeight='700'
              fontSize='15px'
              color='#93a2ba'
              zIndex='5'
              w='0'
              minW='180px'
            >
              <MenuItem
                icon={
                  <Circle size='18px'>
                    <Image src='/images/18.jpg' borderRadius='50%' />
                  </Circle>
                }
                onClick={() => history.push('/profile')}
              >
                Profile
              </MenuItem>
              <MenuItem onClick={() => history.push('/my-activity')}>Activity</MenuItem>
              <MenuItem
                icon={<Home width='16px' fill='#93a2ba' />}
                onClick={() => history.push('/home')}
              >
                Home
              </MenuItem>
              <MenuItem
                icon={<Courses width='16px' fill='#93a2ba' />}
                onClick={() => history.push('/courses')}
              >
                Courses
              </MenuItem>
              <MenuItem
                icon={<Quizzes width='16px' fill='#93a2ba' />}
                onClick={() => history.push('/quizzes')}
              >
                Quizzes
              </MenuItem>
              <MenuItem
                icon={
                  <Attendance
                    width='16px'
                    fill='#93a2ba'
                    onClick={() => history.push('/attendance')}
                  />
                }
              >
                Attendance
              </MenuItem>
              <MenuItem icon={<LiveSessions width='16px' fill='#93a2ba' />}>Live Sessions</MenuItem>
              <MenuItem icon={<Certificates width='16px' />}>Certificates</MenuItem>
              <MenuItem
                icon={<AnnouncementIcon width='16px' />}
                onClick={() => history.push('/announcements')}
              >
                Announcements
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
        <AdvancedSearchModal isOpen={isOpen} onClose={onClose} title={`Advanced Search`} parameters={parameters} />
      </Box>
    )
  );
}
